<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="policyServiceIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)"  @click="urlTo('policyServiceIndex')">政策知识</a> / <span>政策文件详情</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="details">
            <h2 class="details_tit1" style="   ">{{detail.title}}
             <!-- <a @click="open(detail.title)" style="color: #2b60e2;font-size: 12px" href="javascript:void(0)"><u>纠错</u></a>-->
            </h2>

            <p class="details_time" style="display: none">
              <span> 发布日期：{{detail.policy_date}}</span>
            </p>
            <el-tabs v-model="activeName">
              <el-tab-pane label="政策文件" name="first">
            <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab">
              <tr>
                <td width="8%" class="grey">政策名称</td>
                <td width="40%">{{detail.title}}</td>
                <td width="8%" class="grey">发布机构</td>
                <td width="40%">{{detail.party_name}}</td>
              </tr>
              <tr>
                <td class="grey">文号</td>
                <td>{{detail.policy_number}}</td>
                <td class="grey">政策级别</td>
                <td>{{detail.policy_grade_name}}</td>
              </tr>
              <tr>
                <td class="grey">主题分类</td>
                <td>{{detail.policy_at_name}}</td>
                <td class="grey">公文种类</td>
                <td>{{detail.policy_type_name}}</td>
              </tr>
              <tr>
                <td class="grey" >摘要</td>
                <td colspan="3" style="padding-top: 5px;padding-bottom: 5px;">{{detail.policy_abstract}}</td>
              </tr>
              <tr>
                <td class="grey">发布时间</td>
                <td>{{detail.policy_date}}</td>
                <td class="grey">附件下载</td>
                <td><a  v-for="item in detail.attachDataList" :href="getFileUrl(item.attach_id)" target="_blank" style="margin-right: 10px;display: block" >【{{item.attach_name}}】</a></td>
              </tr>
            </table>
                <div class="details_con">
                  <div class="details_con_left" style="width: 97%;margin: 0 auto;">
                    <dl>
                      <dd id="content"></dd>
                    </dl>
                    <!--                <p v-if="!this.$util.isEmpty(detail.attachIdList)">附件：<a href="javascript:void(0)" @click="downloadAttach">{{detail.title}}</a></p>-->
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="政策解读" name="two">
                筛 选：
                <el-input
                  style="width: 250px"
                  placeholder="请输入标题"
                  v-model="title"
                  clearable>
                </el-input>
                <el-button @click="getInterpret" type="primary" style="margin-bottom: 15px">搜索</el-button>
               <div v-if="dataObjList.length>0">
                <el-collapse  v-model="activeName2" accordion>
                  <el-collapse-item v-for="(item,index) in dataObjList" :key="index+'ppdid'">
                    <template slot="title">
                      疑问：{{item.piTitle}}<i class="header-icon el-icon-info"></i>
                    </template>
                 <div style="color: #9d9d9d">解答：{{item.piRemark}}</div>  <a  style="float: right;color: #2c62ec" href="javascript:void(0)" @click="errorCorrection(item.piId,'policy_interpret',item.piTitle)">纠错</a>
                  </el-collapse-item>
                </el-collapse>

               </div>

                <div v-else>
                  <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                    <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                    <div>暂无数据</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>
    <el-dialog :title="errorTitle" :visible.sync="showFloat">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item  label="反馈标题" :label-width="formLabelWidth" prop='errorCorrectionName'>
          <el-input maxlength="50" v-model="ruleForm.errorCorrectionName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="反馈内容"  :label-width="formLabelWidth2" prop='errorCorrectionContent'>
          <el-input type="textarea" maxlength="249"  v-model="ruleForm.errorCorrectionContent" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div  slot="footer" class="dialog-footer">
        <el-button @click="showFloat = false">取 消</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <div   style="margin-top: 0px">
      <div style="text-align: center;height: 50px;line-height: 50px;"><el-pagination
        layout="prev, pager, next"
        :total="total" :page-size="pageSize3" @current-change="pageChange" @prev-click="prevClick" :hide-on-single-page="true" @next-click="nextClieck">
      </el-pagination>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "PolicyDetail",
    components: {
      headers, fixedDiv, footers
    },
    data() {
      return {
        activeName2: '1',
        title: '',
        activeName: 'first',
        pageNum3:1,
        total:1,
        pageSize3: 10,
        ruleForm: {
          errorCorrectionName:'',
          errorCorrectionContent:'',
        },
        rules: {
          errorCorrectionName: [
            {required: true, message: '请输入', trigger: 'blur'},
          ],
          errorCorrectionContent: [
            {required: true, message: '请输入纠正内容', trigger: 'blur'},
          ],
        },
        dataObjList:[],
        formLabelWidth: '80px',
        formLabelWidth2: '80px',
        formLabelHeight: '300px',
        showFloat:false,
        isDisabled:false,
        detail: {},
        detail_id: '',
        knowId: '',
        errorTitle: '',
        errorCorrectionContent: '',
        errorCorrectionName: '',
      }
    },
    mounted() {
      var t=this;
      this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.isCertification=='1'){
            t.people_name=response.data.data.userName;
            t.people_id=response.data.data.userId;
            t.people_idcard=response.data.data.userIdcard;
            t.people_tel=response.data.data.userTel;
          }
        }
      })
    },
    created() {
      this.detail_id = this.$route.query.detail_id;
      this.saveType='policy';
      this.getDetail();
      this.getInterpret();
    },
    methods: {
      getFileUrl(a){
        return this.$util.getAttach(a)
      },
      //获取政策文件详细
      getDetail() {
        this.$https.post("/api/policy/getPolicy.do", {data_id: this.detail_id}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.detail = response.data.data;
            $('#content').html(this.detail.data_content)
            // $('#policy_abstract').html(this.detail.policy_abstract)
          }
        });
      },
      errorCorrection(id,type,title){
     this.showFloat=true;
        this.saveType=type;
        this.knowId=id;
        this.errorTitle=title;
      },

      open(title) {
        this.errorTitle=title;
        this.knowId=this.detail_id;
        this.showFloat=true;
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      pageChange(a){
        this.pageNum3=a
        this.getInterpret();
      },
      prevClick(a){

        this.pageNum3=this.pageNum3-1;
        this.getInterpret(a);
      },
      nextClieck(a){
        this.pageNum3=this.pageNum3+1;
        this.getInterpret(a);
      },
      getInterpret(){
        this.dataObjList=[];
        var t=this;
        this.$https.post("/api/policy/getPolicyInterpret.do", {pageNum:this.pageNum3,pageSize:this.pageSize3,title:this.title,data_id: this.detail_id}, response => {
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            if(response.data.data.dataList && response.data.data.dataList.length>0){

              t.dataObjList=response.data.data.dataList;
              t.total=response.data.data.total;
              // t.dataObjList.push(response.data.data)total;
            }
          }
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isDisabled=true;
            var t=this;
            const options={
              peopleName:t.people_name,
              peopleId:t.people_id,
              knowId:t.knowId,
              peopleIdcard:t.people_idcard,
              peopleTel:t.people_tel,
              errorCorrectionName:t.ruleForm.errorCorrectionName,
              errorCorrectionContent:t.ruleForm.errorCorrectionContent,
              feedbackType:t.saveType,
            }
            this.$https.post("/api/policy/saveError.do",options,response=>{
              if (response.status === 200 && response.data.code===200) {
                t.showFloat=false;
                this.$alert('提交成功，我们会尽快处理！', '', {
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }else {
                this.$message.error('提交失败！请稍后重试');
                t.isDisabled=false;
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //下载附件
      // downloadAttach() {
      //   this.$https.downloadFile("/attach/download.do", {attachId: this.detail.attachIdList[0],}, response => {
      //   });
      // }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/detail/PolicyDetail.vue